import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#07070a', borderTop: '1px solid rgba(246,241,231,0.08)', paddingTop: 80, paddingBottom: 40 }}>
      <div className="container">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 48, marginBottom: 64 }}>

          {/* Brand */}
          <div>
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontFamily: 'var(--font-serif)', fontSize: 26, color: '#d4b06a', letterSpacing: '5px', lineHeight: 1 }}>SUDATH</div>
              <div style={{ fontFamily: 'var(--font-sans)', fontSize: 9, letterSpacing: '6px', color: 'rgba(246,241,231,0.3)', textTransform: 'uppercase', marginTop: 4 }}>GEMS</div>
            </div>
            <p style={{ fontSize: 13, color: 'rgba(246,241,231,0.5)', lineHeight: 1.8, marginBottom: 24 }}>
              Purveyors of the world's finest natural gemstones, ethically sourced from the ancient mines of Sri Lanka. Every stone certified. Every provenance guaranteed.
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
              {['W', 'I', 'F'].map((s, i) => (
                <a key={i} href="#" style={{
                  width: 34, height: 34, border: '1px solid rgba(246,241,231,0.12)', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, color: 'rgba(246,241,231,0.4)', fontFamily: 'var(--font-sans)',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#d4b06a'; e.currentTarget.style.color = '#d4b06a'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(246,241,231,0.12)'; e.currentTarget.style.color = 'rgba(246,241,231,0.4)'; }}>
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* Collection */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-sans)', fontSize: 10.5, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#d4b06a', marginBottom: 24, fontWeight: 500 }}>Collection</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[['Blue Sapphire', '/shop?category=sapphire'], ['Padparadscha', '/shop?category=sapphire'], ['Star Ruby', '/shop?category=ruby'], ['Alexandrite', '/shop?category=alexandrite'], ['Spinel', '/shop?category=spinel'], ['Moonstone', '/shop?category=moonstone']].map(([label, href]) => (
                <li key={label}>
                  <Link to={href} style={{ fontSize: 13, color: 'rgba(246,241,231,0.5)', transition: 'color 0.2s', fontFamily: 'var(--font-sans)' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#d4b06a'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(246,241,231,0.5)'}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-sans)', fontSize: 10.5, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#d4b06a', marginBottom: 24, fontWeight: 500 }}>Information</h4>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[['About Sudath Gems', '/about'], ['Our Story', '/about'], ['Certification & Trust', '/about'], ['Shipping & Delivery', '/about'], ['Returns Policy', '/about'], ['Contact Us', '/contact']].map(([label, href]) => (
                <li key={label}>
                  <Link to={href} style={{ fontSize: 13, color: 'rgba(246,241,231,0.5)', transition: 'color 0.2s', fontFamily: 'var(--font-sans)' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#d4b06a'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(246,241,231,0.5)'}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: 'var(--font-sans)', fontSize: 10.5, letterSpacing: '2.5px', textTransform: 'uppercase', color: '#d4b06a', marginBottom: 24, fontWeight: 500 }}>Contact</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {[
                { icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>, label: 'Ratnapura, Sri Lanka' },
                { icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>, label: 'info@ceylongems.com' },
                { icon: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.99 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.92 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>, label: '+94 77 123 4567' },
              ].map(({ icon, label }) => (
                <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ color: '#d4b06a', flexShrink: 0 }}>{icon}</span>
                  <span style={{ fontSize: 13, color: 'rgba(246,241,231,0.5)', fontFamily: 'var(--font-sans)' }}>{label}</span>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 24, padding: '14px 16px', border: '1px solid rgba(246,241,231,0.08)', borderRadius: 8, background: 'rgba(246,241,231,0.03)' }}>
              <p style={{ fontSize: 10.5, color: '#d4b06a', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 6, fontFamily: 'var(--font-sans)', fontWeight: 500 }}>Secure Payments</p>
              <p style={{ fontSize: 12, color: 'rgba(246,241,231,0.4)', fontFamily: 'var(--font-sans)' }}>All payments via Stripe. Prices in USD.</p>
              <div style={{ marginTop: 10, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {['VISA', 'MC', 'AMEX'].map(c => (
                  <span key={c} style={{ padding: '3px 10px', border: '1px solid rgba(246,241,231,0.12)', borderRadius: 3, fontSize: 10, color: 'rgba(246,241,231,0.35)', letterSpacing: 1, fontFamily: 'var(--font-sans)' }}>{c}</span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Trust row */}
        <div className="footer-trust-row" style={{ borderTop: '1px solid rgba(246,241,231,0.06)', paddingTop: 32, marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
            {['GIA Certified', 'Ethically Sourced', 'Secure Checkout', 'Worldwide Shipping', '30-Day Returns'].map(text => (
              <div key={text} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#d4b06a' }} />
                <span style={{ fontSize: 10.5, letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(246,241,231,0.35)', fontFamily: 'var(--font-sans)', fontWeight: 500 }}>{text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom-row" style={{ borderTop: '1px solid rgba(246,241,231,0.06)', paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: 12, color: 'rgba(246,241,231,0.25)', fontFamily: 'var(--font-sans)' }}>
            © {new Date().getFullYear()} Sudath Gems. All rights reserved. Ratnapura, Sri Lanka.
          </p>
          <div style={{ display: 'flex', gap: 24 }}>
            {['Privacy Policy', 'Terms of Service'].map(l => (
              <a key={l} href="#" style={{ fontSize: 12, color: 'rgba(246,241,231,0.25)', fontFamily: 'var(--font-sans)', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = '#d4b06a'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(246,241,231,0.25)'}>{l}</a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width: 768px) {
          footer { padding-top: 56px !important; }
          footer .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 36px 24px !important; margin-bottom: 40px !important; }
          footer .footer-trust-row { display: none !important; }
          footer .footer-bottom-row { flex-direction: column !important; align-items: center !important; text-align: center !important; gap: 16px !important; }
        }
        @media(max-width: 480px) {
          footer .footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </footer>
  );
}
